var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeploymentImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 179.5 172.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#193a5f;}.cls-4{fill:#bfc3ce;}.cls-5{fill:#fff;}.cls-6{fill:#dce8ff;}.cls-7{clip-path:url(#clip-path-3);}.cls-8{fill:#beccd5;}.cls-9{fill:#cdcdcd;}.cls-10{fill:#60a4c2;}.cls-11{fill:#9900a6;}.cls-12{fill:#eebd3a;}.cls-13{fill:#cacaca;}.cls-14{fill:#c84b2a;}.cls-15{fill:#a9c732;}.cls-16{fill:#828282;}.cls-17{fill:#bdc2c5;}.cls-18{fill:#979797;}.cls-19{fill:#505050;}.cls-20{fill:#636363;}.cls-21{fill:#999;}.cls-22{fill:#323b8c;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 179.5,
    height: 172.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.82,
    y: 123.57,
    width: 19.18,
    height: 2.14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    className: "cls-3",
    d: "M128.77,123.57H52A1.63,1.63,0,0,1,50.42,122h0V66.69A1.63,1.63,0,0,1,52,65.07h76.73a1.62,1.62,0,0,1,1.62,1.62h0V122a1.62,1.62,0,0,1-1.62,1.62h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    className: "cls-4",
    d: "M128.77,123.57H52A1.63,1.63,0,0,1,50.42,122h0v-9.44h80V122a1.63,1.63,0,0,1-1.62,1.62h0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_824",
    "data-name": "Rectangle 824",
    className: "cls-5",
    x: 53.21,
    y: 67.85,
    width: 74.41,
    height: 42.09
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_825",
    "data-name": "Rectangle 825",
    className: "cls-6",
    x: 53.21,
    y: 67.85,
    width: 74.41,
    height: 42.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    className: "cls-4",
    d: "M81.39,123.57a38.69,38.69,0,0,1-1.83,5.77h21.7a38.69,38.69,0,0,1-1.83-5.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    className: "cls-8",
    d: "M100,125.71c-.2-.66-.39-1.38-.57-2.14h-18c-.18.76-.37,1.48-.57,2.14Z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    className: "cls-3",
    d: "M105.3,129.24H75.51a2,2,0,0,0-2,2h33.73a2,2,0,0,0-2-2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_827",
    "data-name": "Rectangle 827",
    className: "cls-9",
    x: 122.6,
    y: 20.3,
    width: 17.55,
    height: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_828",
    "data-name": "Rectangle 828",
    className: "cls-10",
    x: 60.46,
    y: 107.97,
    width: 19.15,
    height: 1.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    className: "cls-11",
    d: "M69,102.61H40.41l-7.17-6.42L34,95.4l6.86,6.14H69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_829",
    "data-name": "Rectangle 829",
    className: "cls-12",
    x: 53.03,
    y: 32.81,
    width: 1.07,
    height: 48.17,
    transform: "translate(-24.27 63.91) rotate(-51.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_830",
    "data-name": "Rectangle 830",
    className: "cls-13",
    x: 57.08,
    y: 43.61,
    width: 0.54,
    height: 41.26,
    transform: "translate(-28.57 70.05) rotate(-52.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    className: "cls-14",
    d: "M107.49,68.72l-.39-.37,4.44-4.79V53.91h.53v9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    className: "cls-9",
    d: "M108.18,72.07l-.79-.73,6.29-6.81V34.47h-2.57V33.4h3.64V65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_831",
    "data-name": "Rectangle 831",
    className: "cls-9",
    x: 113.8,
    y: 81.88,
    width: 17.81,
    height: 1.07
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_832",
    "data-name": "Rectangle 832",
    className: "cls-9",
    x: 116.48,
    y: 85.1,
    width: 29.33,
    height: 1.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    className: "cls-9",
    d: "M133.19,84.56a2.28,2.28,0,1,1,2.27-2.28h0a2.27,2.27,0,0,1-2.27,2.27m0-3.55a1.28,1.28,0,1,0,1.28,1.28h0A1.28,1.28,0,0,0,133.19,81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    className: "cls-9",
    d: "M177.23,85.36a2.27,2.27,0,1,1,2.27-2.27,2.27,2.27,0,0,1-2.27,2.27m0-3.55a1.28,1.28,0,1,0,1.27,1.28h0a1.28,1.28,0,0,0-1.27-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    className: "cls-9",
    d: "M45.6,146.72a2.28,2.28,0,1,1,2.28-2.27,2.27,2.27,0,0,1-2.28,2.27m0-3.55a1.28,1.28,0,1,0,1.28,1.28,1.27,1.27,0,0,0-1.28-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    className: "cls-9",
    d: "M85,172.44a2.28,2.28,0,1,1,2.28-2.28h0A2.28,2.28,0,0,1,85,172.44m0-3.55a1.28,1.28,0,1,0,1.28,1.28h0A1.28,1.28,0,0,0,85,168.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    className: "cls-9",
    d: "M120.33,10.53a2.28,2.28,0,1,1,2.27-2.27h0a2.27,2.27,0,0,1-2.27,2.27m0-3.55a1.28,1.28,0,1,0,1.28,1.28h0A1.28,1.28,0,0,0,120.33,7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    className: "cls-12",
    d: "M33.53,43.3A2.27,2.27,0,1,1,35.81,41h0a2.28,2.28,0,0,1-2.28,2.27m0-3.55A1.28,1.28,0,1,0,34.81,41h0a1.28,1.28,0,0,0-1.28-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    className: "cls-9",
    d: "M48.54,86.33a2.27,2.27,0,1,1,2.27-2.27,2.27,2.27,0,0,1-2.27,2.27m0-3.55a1.28,1.28,0,1,0,1.27,1.28h0a1.28,1.28,0,0,0-1.27-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    className: "cls-9",
    d: "M67.12,127.15a2.27,2.27,0,1,1,2.27-2.27,2.27,2.27,0,0,1-2.27,2.27m0-3.55a1.28,1.28,0,0,0,0,2.56,1.28,1.28,0,0,0,1.28-1.28h0a1.29,1.29,0,0,0-1.28-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    className: "cls-9",
    d: "M126.49,125.81a2.27,2.27,0,1,1,2.28-2.27,2.27,2.27,0,0,1-2.28,2.27m0-3.55a1.28,1.28,0,1,0,1.28,1.28h0a1.29,1.29,0,0,0-1.28-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    className: "cls-9",
    d: "M67.12,9.55a2.28,2.28,0,1,1,2.27-2.27,2.27,2.27,0,0,1-2.27,2.27m0-3.55A1.28,1.28,0,1,0,68.4,7.28h0A1.28,1.28,0,0,0,67.12,6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_833",
    "data-name": "Rectangle 833",
    className: "cls-10",
    x: 116.13,
    y: 96.93,
    width: 26.61,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_834",
    "data-name": "Rectangle 834",
    className: "cls-12",
    x: 117.12,
    y: 94.34,
    width: 22.23,
    height: 1.07
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_835",
    "data-name": "Rectangle 835",
    className: "cls-9",
    x: 61.89,
    y: 82.42,
    width: 17.81,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_836",
    "data-name": "Rectangle 836",
    className: "cls-9",
    x: 61.35,
    y: 87.51,
    width: 17.81,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_837",
    "data-name": "Rectangle 837",
    className: "cls-9",
    x: 53.09,
    y: 91.12,
    width: 21.39,
    height: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    className: "cls-9",
    d: "M18.2,59.84,11.48,53.4V49h1v4l6.41,6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    className: "cls-9",
    d: "M111.69,71.71l-.78-.73,17.41-18.79h19v1.07H128.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    className: "cls-9",
    d: "M105.26,84.39l-.78-.73,17.41-18.79h7.37v1.07h-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    className: "cls-9",
    d: "M111.85,74l-.39-.36L128.8,55h18.86v.54H129Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_838",
    "data-name": "Rectangle 838",
    className: "cls-9",
    x: 57.51,
    y: 85.49,
    width: 11.48,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_839",
    "data-name": "Rectangle 839",
    className: "cls-9",
    x: 47.33,
    y: 93.66,
    width: 19.69,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_840",
    "data-name": "Rectangle 840",
    className: "cls-9",
    x: 66.52,
    y: 8.62,
    width: 1,
    height: 17.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    className: "cls-15",
    d: "M169,141.18H153.57l-19.81-12.94.54-.83,19.57,12.78H169Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    className: "cls-9",
    d: "M69.6,28.71h-1v-13l7.64-8,.72.68L69.6,16.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_841",
    "data-name": "Rectangle 841",
    className: "cls-9",
    x: 19.6,
    y: 117.74,
    width: 13.13,
    height: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    className: "cls-9",
    d: "M99.18,155.16l-.78-.74,5.92-6.2h12.55v1.08H104.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_842",
    "data-name": "Rectangle 842",
    className: "cls-13",
    x: 107.9,
    y: 145.54,
    width: 9.51,
    height: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    className: "cls-9",
    d: "M70.81,140H69.73v-29.6H77.5v1.07H70.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_843",
    "data-name": "Rectangle 843",
    className: "cls-9",
    x: 66.52,
    y: 126.55,
    width: 1.07,
    height: 14.73
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_844",
    "data-name": "Rectangle 844",
    className: "cls-9",
    x: 70.05,
    y: 150.07,
    width: 1.07,
    height: 15.86
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_845",
    "data-name": "Rectangle 845",
    className: "cls-9",
    x: 116.06,
    y: 95.69,
    width: 0.54,
    height: 25.29,
    transform: "translate(-37.93 146.69) rotate(-56.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_846",
    "data-name": "Rectangle 846",
    className: "cls-13",
    x: 98.78,
    y: 114.52,
    width: 0.54,
    height: 20.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_847",
    "data-name": "Rectangle 847",
    className: "cls-9",
    x: 96.01,
    y: 114.43,
    width: 1.07,
    height: 12.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    className: "cls-12",
    d: "M73.87,70.28,38.21,42.23V22.37h.54V42L74.2,69.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_848",
    "data-name": "Rectangle 848",
    className: "cls-9",
    x: 82.83,
    y: 50.67,
    width: 1.07,
    height: 19.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    className: "cls-9",
    d: "M47,68.48H35.3L16.22,52.33l.69-.82L35.7,67.41H47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    className: "cls-9",
    d: "M155.6,62.59h-7.11L129.41,46.44l.69-.82,18.78,15.9h6.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    className: "cls-9",
    d: "M161.08,60.44H149.53l-.08-.06-18.93-16,.34-.41,18.86,16h11.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    className: "cls-9",
    x: 140.78,
    y: 38.16,
    width: 0.54,
    height: 24.8,
    transform: "translate(11.34 125.58) rotate(-49.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_850",
    "data-name": "Rectangle 850",
    className: "cls-9",
    x: 154.66,
    y: 137.51,
    width: 9.88,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_851",
    "data-name": "Rectangle 851",
    className: "cls-9",
    x: 95.31,
    y: 13.63,
    width: 1.07,
    height: 51.03
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_852",
    "data-name": "Rectangle 852",
    className: "cls-13",
    x: 78.45,
    y: 57.1,
    width: 0.54,
    height: 15.27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_853",
    "data-name": "Rectangle 853",
    className: "cls-9",
    x: 79.92,
    y: 60.45,
    width: 1,
    height: 11.92
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_854",
    "data-name": "Rectangle 854",
    className: "cls-9",
    x: 122.47,
    y: 22.39,
    width: 10.31,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_855",
    "data-name": "Rectangle 855",
    className: "cls-9",
    x: 9.51,
    y: 88.63,
    width: 14.47,
    height: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    className: "cls-9",
    d: "M38.09,71.19a1.32,1.32,0,1,1-1.35-1.28h0a1.32,1.32,0,0,1,1.35,1.28"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_856",
    "data-name": "Rectangle 856",
    className: "cls-9",
    x: 31.35,
    y: 61.42,
    width: 0.54,
    height: 11.44,
    transform: "translate(-40.66 50.29) rotate(-51.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_857",
    "data-name": "Rectangle 857",
    className: "cls-9",
    x: 35.82,
    y: 60.18,
    width: 1.07,
    height: 27.94,
    transform: "translate(-44.11 55.58) rotate(-50.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    className: "cls-16",
    d: "M14.17,49a2,2,0,1,1-2-2h0a2,2,0,0,1,2,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    className: "cls-10",
    d: "M62.29,108.66a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    className: "cls-17",
    d: "M110.19,33.77a1.9,1.9,0,1,1-1.89-1.89,1.89,1.89,0,0,1,1.89,1.89h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    className: "cls-17",
    d: "M108.3,36.58a2.81,2.81,0,1,1,2.81-2.81,2.81,2.81,0,0,1-2.81,2.81m0-5.19a2.39,2.39,0,1,0,2.39,2.38h0a2.39,2.39,0,0,0-2.39-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    className: "cls-17",
    d: "M110.14,134.12a1.9,1.9,0,1,1-1.9-1.89,1.89,1.89,0,0,1,1.9,1.89h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    className: "cls-17",
    d: "M108.24,136.93a2.81,2.81,0,1,1,2.82-2.81,2.81,2.81,0,0,1-2.82,2.81m0-5.2a2.39,2.39,0,1,0,2.39,2.39h0a2.39,2.39,0,0,0-2.39-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    className: "cls-11",
    d: "M33.55,93.8a1.9,1.9,0,1,1-1.89-1.89,1.9,1.9,0,0,1,1.89,1.89h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    className: "cls-11",
    d: "M31.66,96.62a2.82,2.82,0,1,1,2.81-2.82h0a2.81,2.81,0,0,1-2.81,2.81m0-5.2a2.39,2.39,0,1,0,2.39,2.39h0a2.39,2.39,0,0,0-2.39-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    className: "cls-18",
    d: "M75.52,69,40.22,41.35l0-23.45H42.6l0,22.27L77,67.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    className: "cls-18",
    d: "M101.18,65H98.77v-15a7.37,7.37,0,0,1,7.36-7.37h2.59v2.41h-2.59a5,5,0,0,0-4.95,5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_858",
    "data-name": "Rectangle 858",
    className: "cls-18",
    x: 115.11,
    y: 76.79,
    width: 10.45,
    height: 2.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    className: "cls-18",
    d: "M131.05,79.2h-6.56V76.79h6.56a5,5,0,0,0,4.95-5V63.62h2.41v8.22a7.37,7.37,0,0,1-7.36,7.36"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_859",
    "data-name": "Rectangle 859",
    className: "cls-18",
    x: 91.29,
    y: 47.38,
    width: 2.41,
    height: 15.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    className: "cls-18",
    d: "M93.7,48.45H91.29V33.58a5,5,0,0,0-5-4.95H83.9V26.22h2.44a7.37,7.37,0,0,1,7.36,7.36Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_860",
    "data-name": "Rectangle 860",
    className: "cls-18",
    x: 63.72,
    y: 103.76,
    width: 7.52,
    height: 2.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    className: "cls-18",
    d: "M51.66,113.81H49.25v-2.68a7.38,7.38,0,0,1,7.37-7.37h8.17v2.41H56.62a5,5,0,0,0-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    className: "cls-18",
    d: "M44.3,123.85h-1v-2.41h1a5,5,0,0,0,5-5v-5.67h2.41v5.67a7.37,7.37,0,0,1-7.36,7.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    className: "cls-18",
    d: "M75,132.63H72.6A7.38,7.38,0,0,1,80,125.26h3.69v2.41H80a5,5,0,0,0-5,5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    className: "cls-18",
    d: "M84.74,127.67H81.15v-2.41h3.59a5,5,0,0,0,5-5v-6H92.1v6a7.37,7.37,0,0,1-7.36,7.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    className: "cls-18",
    d: "M112.47,43.8a3.13,3.13,0,1,1-3.12-3.13,3.12,3.12,0,0,1,3.12,3.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    className: "cls-18",
    d: "M126,100.62l4.48,0L127.06,105Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    className: "cls-19",
    d: "M150.72,124.76h-4.48l3.33-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    className: "cls-19",
    d: "M148.06,124.1,144.84,122l1.34-2,3.22,2.14Zm-6.56-4.36-3.35-2.22,1.33-2,3.35,2.22Zm-6.7-4.44-3.35-2.23,1.33-2,3.35,2.23Zm-6.7-4.45-3.35-2.22,1.34-2,3.35,2.22Zm-6.69-4.44-3.35-2.22,1.33-2,3.35,2.22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_861",
    "data-name": "Rectangle 861",
    className: "cls-18",
    x: 140.58,
    y: 94.31,
    width: 2.41,
    height: 34.26,
    transform: "translate(-29.26 168.58) rotate(-56.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    className: "cls-19",
    d: "M64.31,100.46h-4V98.05h4Zm-8,0h-4V98.05h4Zm-8,0H46a7.46,7.46,0,0,1-2.1-.3l.68-2.32a4.88,4.88,0,0,0,1.42.21h2.23Zm-8.2-3a7.35,7.35,0,0,1-1.41-4.34V93H41v.13A5,5,0,0,0,42,96Zm1-8.49H38.63v-4H41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    className: "cls-19",
    d: "M8.53,78.93H7.37A7.37,7.37,0,0,1,0,71.57V68.35H2.41v3.22a5,5,0,0,0,5,5H8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    className: "cls-19",
    d: "M8.53,78.93H7.37A7.37,7.37,0,0,1,0,71.57V68.35H2.41v3.22a5,5,0,0,0,5,5H8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    className: "cls-19",
    d: "M2.41,68.6H0V67.44a7.38,7.38,0,0,1,7.37-7.37h.8v2.41h-.8a5,5,0,0,0-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    className: "cls-19",
    d: "M2.41,68.6H0V67.44a7.38,7.38,0,0,1,7.37-7.37h.8v2.41h-.8a5,5,0,0,0-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    className: "cls-19",
    d: "M12.12,61.24,7.53,64.78V57.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    className: "cls-19",
    d: "M41,85.05H38.62V83.89a5,5,0,0,0-4.95-5H8.19V76.53H33.67A7.37,7.37,0,0,1,41,83.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_862",
    "data-name": "Rectangle 862",
    className: "cls-18",
    x: 117.25,
    y: 88.31,
    width: 24.11,
    height: 2.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    className: "cls-15",
    d: "M134.2,130.05a2,2,0,1,1,2.05-2h0a2.05,2.05,0,0,1-2.05,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    className: "cls-9",
    d: "M56.21,87.81a2,2,0,1,1,2-2,2,2,0,0,1-2,2h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    className: "cls-9",
    d: "M108.74,131.31h-1V115l-8.54-5.61.54-.83,9,5.91Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_863",
    "data-name": "Rectangle 863",
    className: "cls-9",
    x: 113.77,
    y: 102.07,
    width: 1,
    height: 26.19,
    transform: "translate(-44.85 146.81) rotate(-56.47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    className: "cls-9",
    d: "M141.23,158a2.27,2.27,0,1,1,2.27-2.27,2.28,2.28,0,0,1-2.27,2.27m0-3.55a1.28,1.28,0,0,0-1.28,1.28,1.28,1.28,0,1,0,2.55,0h0a1.27,1.27,0,0,0-1.27-1.28"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_864",
    "data-name": "Rectangle 864",
    className: "cls-9",
    x: 136.68,
    y: 149.35,
    width: 1,
    height: 6.65,
    transform: "translate(-66.26 179.85) rotate(-55.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    className: "cls-15",
    d: "M80.17,6.2a1.9,1.9,0,1,1-1.9-1.89,1.9,1.9,0,0,1,1.9,1.89h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    className: "cls-15",
    d: "M78.27,9A2.82,2.82,0,1,1,81.09,6.2,2.81,2.81,0,0,1,78.27,9m0-5.2a2.39,2.39,0,1,0,2.39,2.39h0a2.39,2.39,0,0,0-2.39-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    className: "cls-17",
    d: "M98.74,156.85A1.9,1.9,0,1,1,96.85,155a1.89,1.89,0,0,1,1.89,1.89h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    className: "cls-17",
    d: "M96.85,159.66a2.81,2.81,0,1,1,2.81-2.81,2.81,2.81,0,0,1-2.81,2.81m0-5.2a2.39,2.39,0,1,0,2.38,2.39h0a2.39,2.39,0,0,0-2.38-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    className: "cls-9",
    d: "M83.6,169.4l-6.19-5.92v-6.85h1.07V163l5.86,5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    className: "cls-14",
    d: "M113.07,53.05a1.32,1.32,0,1,1-1.35-1.28h0a1.31,1.31,0,0,1,1.34,1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    className: "cls-10",
    d: "M145.22,97.16a1.32,1.32,0,1,1-1.35-1.28,1.31,1.31,0,0,1,1.35,1.28h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    className: "cls-10",
    d: "M80,56.22a1.32,1.32,0,1,1-1.35-1.28h0A1.31,1.31,0,0,1,80,56.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    className: "cls-16",
    d: "M162.54,60.1a1.31,1.31,0,1,1-1.35-1.28h0a1.32,1.32,0,0,1,1.34,1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    className: "cls-16",
    d: "M41.76,50.91a1.32,1.32,0,1,1-1.35-1.28,1.32,1.32,0,0,1,1.35,1.28h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    className: "cls-16",
    d: "M53.49,91.39a1.32,1.32,0,1,1-1.35-1.28h0a1.33,1.33,0,0,1,1.35,1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    className: "cls-16",
    d: "M100.57,134.2a1.32,1.32,0,1,1-1.35-1.28h0a1.31,1.31,0,0,1,1.35,1.28"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_865",
    "data-name": "Rectangle 865",
    className: "cls-13",
    x: 72.88,
    y: 142.85,
    width: 0.54,
    height: 20.63
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    className: "cls-16",
    d: "M74.68,162.53a1.32,1.32,0,1,1-1.35-1.28h0a1.32,1.32,0,0,1,1.35,1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    className: "cls-16",
    d: "M109.35,145.78A1.32,1.32,0,1,1,108,144.5h0a1.31,1.31,0,0,1,1.35,1.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    className: "cls-9",
    d: "M127.89,116.91a1.32,1.32,0,1,1,1-1.59,1.32,1.32,0,0,1-1,1.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    className: "cls-20",
    d: "M21.19,117.88a1.32,1.32,0,1,1-1.35-1.28h0a1.32,1.32,0,0,1,1.35,1.28"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_866",
    "data-name": "Rectangle 866",
    className: "cls-9",
    x: 38.43,
    y: 129.2,
    width: 1,
    height: 16.39,
    transform: "translate(-84.75 66.01) rotate(-44.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    className: "cls-17",
    d: "M49.12,67.85a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    className: "cls-17",
    d: "M72.69,167.92a2.1,2.1,0,1,1-2.1-2.1,2.1,2.1,0,0,1,2.1,2.1h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    className: "cls-13",
    d: "M59.65,139.3H45.82l-.08-.07-10.16-9.89L36,129,46,138.76H59.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    className: "cls-16",
    d: "M60.92,139a1.32,1.32,0,1,1-1.35-1.28A1.31,1.31,0,0,1,60.92,139"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    className: "cls-9",
    d: "M22.57,89a1.32,1.32,0,0,1,1.28-1.35A1.32,1.32,0,1,1,22.57,89h0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_867",
    "data-name": "Rectangle 867",
    className: "cls-9",
    x: 154.62,
    y: 105.95,
    width: 19.91,
    height: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    className: "cls-9",
    d: "M173.13,106.34a1.32,1.32,0,1,1,1.35,1.28h0a1.31,1.31,0,0,1-1.35-1.28"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_868",
    "data-name": "Rectangle 868",
    className: "cls-9",
    x: 152.93,
    y: 107.29,
    width: 14.47,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_869",
    "data-name": "Rectangle 869",
    className: "cls-9",
    x: 103.63,
    y: 7.54,
    width: 14.91,
    height: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    className: "cls-11",
    d: "M105,7.69a1.32,1.32,0,1,1-1.35-1.28h0A1.32,1.32,0,0,1,105,7.69"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_870",
    "data-name": "Rectangle 870",
    className: "cls-9",
    x: 109.08,
    y: 8.88,
    width: 9.87,
    height: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    className: "cls-9",
    d: "M85.41,49.47a2,2,0,1,1-2-2,2,2,0,0,1,2,2h0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_871",
    "data-name": "Rectangle 871",
    className: "cls-9",
    x: 160.48,
    y: 82.59,
    width: 15.3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_872",
    "data-name": "Rectangle 872",
    className: "cls-9",
    x: 38.77,
    y: 129.4,
    width: 0.54,
    height: 10.36,
    transform: "translate(-83.73 67.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_873",
    "data-name": "Rectangle 873",
    className: "cls-9",
    x: 57.13,
    y: 47.11,
    width: 0.54,
    height: 39.36,
    transform: "translate(-30.57 70.99) rotate(-52.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_874",
    "data-name": "Rectangle 874",
    className: "cls-9",
    x: 19.14,
    y: 53.92,
    width: 0.54,
    height: 6.13,
    transform: "translate(-35.41 32.1) rotate(-46.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_875",
    "data-name": "Rectangle 875",
    className: "cls-9",
    x: 100.47,
    y: 109.7,
    width: 0.54,
    height: 13.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_876",
    "data-name": "Rectangle 876",
    className: "cls-9",
    x: 110.98,
    y: 143.36,
    width: 5.89,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_877",
    "data-name": "Rectangle 877",
    className: "cls-9",
    x: 114.22,
    y: 105.64,
    width: 0.54,
    height: 6.82,
    transform: "translate(-38.95 147.24) rotate(-57.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_878",
    "data-name": "Rectangle 878",
    className: "cls-9",
    x: 158.78,
    y: 84.61,
    width: 13.57,
    height: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    className: "cls-9",
    d: "M164.18,43a2.28,2.28,0,1,1,2.27-2.28h0A2.28,2.28,0,0,1,164.18,43m0-3.55a1.28,1.28,0,1,0,1.27,1.27h0a1.27,1.27,0,0,0-1.27-1.27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_879",
    "data-name": "Rectangle 879",
    className: "cls-9",
    x: 148.51,
    y: 40.26,
    width: 14.23,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_880",
    "data-name": "Rectangle 880",
    className: "cls-9",
    x: 146.81,
    y: 42.28,
    width: 12.5,
    height: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    className: "cls-9",
    d: "M35.33,158a2.27,2.27,0,1,1,2.27-2.27A2.28,2.28,0,0,1,35.33,158m0-3.55a1.28,1.28,0,1,0,1.27,1.28h0a1.27,1.27,0,0,0-1.27-1.28"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_881",
    "data-name": "Rectangle 881",
    className: "cls-9",
    x: 36.77,
    y: 155.25,
    width: 15.3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_882",
    "data-name": "Rectangle 882",
    className: "cls-9",
    x: 40.19,
    y: 157.94,
    width: 13.57,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_883",
    "data-name": "Rectangle 883",
    className: "cls-9",
    x: 64.61,
    y: 13.44,
    width: 0.54,
    height: 11.43
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_884",
    "data-name": "Rectangle 884",
    className: "cls-9",
    x: 71.04,
    y: 16.92,
    width: 0.54,
    height: 11.43
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_885",
    "data-name": "Rectangle 885",
    className: "cls-9",
    x: 62.74,
    y: 17.28,
    width: 0.54,
    height: 12.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    className: "cls-9",
    d: "M171.14,96.42h-2.4l-3-2.06.3-.44,2.88,2h2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    className: "cls-9",
    d: "M171,98.29h-3.34l-7.87-5.61.32-.43,7.72,5.51H171Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    className: "cls-10",
    d: "M134.08,65.58a1.89,1.89,0,1,1-1.89-1.9,1.89,1.89,0,0,1,1.89,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    className: "cls-10",
    d: "M132.19,68.39A2.82,2.82,0,1,1,135,65.58a2.81,2.81,0,0,1-2.81,2.81m0-5.2a2.39,2.39,0,1,0,2.39,2.39h0a2.4,2.4,0,0,0-2.39-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    className: "cls-17",
    d: "M144.62,20.67a1.9,1.9,0,1,1-1.9-1.89,1.89,1.89,0,0,1,1.9,1.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    className: "cls-17",
    d: "M142.72,23.48a2.81,2.81,0,1,1,2.82-2.81,2.81,2.81,0,0,1-2.82,2.81m0-5.2a2.39,2.39,0,1,0,2.39,2.39h0a2.4,2.4,0,0,0-2.39-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    className: "cls-21",
    d: "M118.67,13.54h-1.31v-.65h-.29v.65h-2.18v-.65h-.29v.65h-1.31a.27.27,0,0,0-.28.28V17.3a.28.28,0,0,0,.28.28h5.38a.29.29,0,0,0,.28-.28V13.82a.28.28,0,0,0-.28-.28m-4.58,1.38a.51.51,0,1,1,.51.52h0a.51.51,0,0,1-.51-.52m3.62,2h-3.46v-.38h3.46Zm-.35-1.43a.52.52,0,1,1,.51-.52h0a.51.51,0,0,1-.51.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    className: "cls-21",
    d: "M112.23,20.93h-1.07v-3h1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    className: "cls-21",
    d: "M112.23,24.15h-1.07v-3h1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    className: "cls-21",
    d: "M111.7,24.22a1.18,1.18,0,0,0-.37,2.31v-.41A.81.81,0,0,1,111,25a.83.83,0,0,1,1.1-.36.82.82,0,0,1,.35,1.1.79.79,0,0,1-.35.35v.41a1.18,1.18,0,0,0-.37-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    className: "cls-21",
    d: "M120.83,20.93h-1.07v-3h1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    className: "cls-21",
    d: "M120.83,24.15h-1.07v-3h1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    className: "cls-21",
    d: "M120.29,24.22a1.18,1.18,0,0,0-1.19,1.17,1.2,1.2,0,0,0,.82,1.14v-.41a.8.8,0,0,1-.35-1.09.81.81,0,0,1,1.09-.36.83.83,0,0,1,.36,1.1.76.76,0,0,1-.36.35v.41a1.18,1.18,0,0,0-.37-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    className: "cls-21",
    d: "M119.25,17.77H112.7a.28.28,0,0,0-.28.28V23a.28.28,0,0,0,.28.28h6.55a.27.27,0,0,0,.28-.28V18.05a.27.27,0,0,0-.28-.28m-1,3.85a.41.41,0,0,1-.42.41h-1.3l.88-.88a.27.27,0,0,0,0-.37.25.25,0,0,0-.36,0h0L115.76,22h-1.59a.41.41,0,0,1-.42-.41h0V20.17a.42.42,0,0,1,.41-.42h3.63a.41.41,0,0,1,.41.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886",
    "data-name": "Rectangle 886",
    className: "cls-21",
    x: 113.81,
    y: 23.57,
    width: 1.76,
    height: 2.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887",
    "data-name": "Rectangle 887",
    className: "cls-21",
    x: 113.81,
    y: 26.6,
    width: 1.76,
    height: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    className: "cls-21",
    d: "M115.86,28.67a.55.55,0,0,1-.51.58h-2a.59.59,0,0,1,0-1.17h2a.56.56,0,0,1,.51.59"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    className: "cls-21",
    x: 116.42,
    y: 23.57,
    width: 1.76,
    height: 2.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889",
    "data-name": "Rectangle 889",
    className: "cls-21",
    x: 116.42,
    y: 26.6,
    width: 1.76,
    height: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    className: "cls-21",
    d: "M116.13,28.67a.55.55,0,0,0,.51.58h2a.59.59,0,0,0,0-1.17h-2a.56.56,0,0,0-.51.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    className: "cls-17",
    d: "M23.56,102c0-1.52-1.49-2.8-3.5-3.17a3.4,3.4,0,0,1,.13,1,3.87,3.87,0,0,1-.56,2,5.19,5.19,0,0,1-1.47,1.52,7.45,7.45,0,0,1-2.55,1.11,5.84,5.84,0,0,0,3.25.91,4.87,4.87,0,0,0,.54,0l3.2,1.49-1.45-1.88A3.32,3.32,0,0,0,23.56,102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    className: "cls-17",
    d: "M19.57,99.81c0-2.32-2.69-4.2-6-4.2s-6,1.88-6,4.2c0,1.76,1.56,3.27,3.76,3.9l-1,2.65L13.94,104c3.14-.14,5.63-2,5.63-4.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    className: "cls-17",
    d: "M100.9,141.64a1.53,1.53,0,0,0-.38-1.14,1.22,1.22,0,0,0-.93-.39H97.41c0-.32,0-.81,0-1.25a2.94,2.94,0,0,0-.68-1.82.89.89,0,0,0-.56-.36H96c-.4,0-.88.16-1,.51a.91.91,0,0,0,0,.49,2.16,2.16,0,0,1,0,.91,8.36,8.36,0,0,1-1.47,2.6,1.2,1.2,0,0,1-.39.2.66.66,0,0,0-.61-.43h-2.4a.48.48,0,0,0-.49.47v.08l0,4.71s0,0,0,0a.67.67,0,0,0,.64.57h3.07a.47.47,0,0,0,.49-.47.33.33,0,0,0,0-.1l0-.15.25.06a8.74,8.74,0,0,0,2.21.62h2.73a1,1,0,0,0,1-.56.91.91,0,0,0,0-.69v-.07a.78.78,0,0,0,.62-.65,1.13,1.13,0,0,0-.17-.86.91.91,0,0,0,.51-1,1.11,1.11,0,0,0-.45-.8.76.76,0,0,0,.31-.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    className: "cls-20",
    d: "M61.18,74.76h-.29v-.23a3.35,3.35,0,0,0-6.68-.31,2.58,2.58,0,0,1,1,2h0a2.06,2.06,0,0,1,2.1,2,2,2,0,0,1-.92,1.66h4.8a2.58,2.58,0,0,0,.23-5.15h-.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    className: "cls-20",
    d: "M57,78.24a1.7,1.7,0,0,0-1.74-1.65H55l-.22,0,0-.21v-.15a2.2,2.2,0,0,0-4.39-.18l0,.19-.19,0H50a1.83,1.83,0,0,0,0,3.66h5.25A1.71,1.71,0,0,0,57,78.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    className: "cls-9",
    d: "M83.49,116.62h-.24v-.24a.09.09,0,0,0-.09-.08H81.83a.08.08,0,0,0-.09.08h0v.24h-1L80.3,116a.11.11,0,0,0-.12-.1H78.43a.11.11,0,0,0-.12.1l-.43.65H75.11a.54.54,0,0,0-.54.54h0v5.19a.54.54,0,0,0,.54.54H83.5a.54.54,0,0,0,.54-.54h0v-5.19a.54.54,0,0,0-.54-.54M79.3,122a2.27,2.27,0,1,1,2.27-2.26A2.26,2.26,0,0,1,79.3,122h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    className: "cls-9",
    d: "M79.3,118.25a1.51,1.51,0,1,0,1.51,1.51,1.51,1.51,0,0,0-1.51-1.51h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    className: "cls-21",
    d: "M155.73,105.26c0,2.44-4.42,5.54-4.42,5.54s-4.42-3.1-4.42-5.54,3.23-2.83,4.42-.75c1.13-2,4.42-1.69,4.42.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    className: "cls-20",
    d: "M62.32,157.61h-.48v6.78a2.55,2.55,0,0,0-1.52.14c-1,.38-1.59,1.16-1.36,1.76s1.21.77,2.19.39a2,2,0,0,0,1.41-1.45h0V160a2.67,2.67,0,0,1,1.37,2.27c0,1.05-.27,1.5-.43,1.62s0,.3.16.2.89-.66.89-2.27-1-2.29-1.67-3a1.69,1.69,0,0,1-.56-1.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    className: "cls-11",
    d: "M97.55,9.05l.15-1.14a8.72,8.72,0,0,0,2.57-2.11c2.27-2.73,2-5,2-5L103,0l-.89.55S99.89,0,96.84,1.8A9.06,9.06,0,0,0,94.37,4L93.22,4a6.45,6.45,0,0,0-3.4,2.37,4.34,4.34,0,0,1,2.74.35l-.45.71s-.07.42.69,1.31,1.2.88,1.2.88l.77-.33a4.41,4.41,0,0,1-.08,2.76,6.47,6.47,0,0,0,2.86-3m1.27-5.47a.76.76,0,1,1,1.08.08h0a.77.77,0,0,1-1.08-.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    className: "cls-10",
    d: "M22.59,140.66c-1.19,0-2.14,1.45-2.14,3.24v.25h3a6.36,6.36,0,0,1,.7-2.49,1.88,1.88,0,0,0-1.54-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    className: "cls-10",
    d: "M22.59,137.89a1.3,1.3,0,1,0,1.36,1.3,1.33,1.33,0,0,0-1.36-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    className: "cls-10",
    d: "M29.72,141.81a3,3,0,0,0-2.52-1.91,2.93,2.93,0,0,0-2.44,1.76,6.17,6.17,0,0,0-.68,2.42c0,.19,0,.38,0,.57s0,.25,0,.37h6.26c0-.12,0-.25,0-.37v-.28a6.47,6.47,0,0,0-.62-2.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    className: "cls-10",
    d: "M27.2,135.83a1.91,1.91,0,1,0,2,1.91,2,2,0,0,0-2-1.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    className: "cls-9",
    d: "M47.49,129.85a5.44,5.44,0,0,0,5.44,5.44,5.37,5.37,0,0,0,2.91-.85l.64,1.12,1-1.95,1-2-2.2-.1-2.21-.1.61,1.08a3.14,3.14,0,0,1-1.81.55,3.24,3.24,0,1,1,2.42-5.39A1.1,1.1,0,1,0,57,126.23a5.44,5.44,0,0,0-9.5,3.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    className: "cls-14",
    d: "M8.26,91.26A2.28,2.28,0,1,1,10.54,89a2.28,2.28,0,0,1-2.28,2.28m0-3.55A1.28,1.28,0,1,0,9.54,89h0a1.27,1.27,0,0,0-1.28-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    className: "cls-9",
    d: "M165.05,95.17a1.32,1.32,0,1,1,1.82-.39,1.31,1.31,0,0,1-1.82.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    className: "cls-14",
    d: "M86.59,146.11a11.52,11.52,0,1,1-11.52-11.52h0a11.52,11.52,0,0,1,11.52,11.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    className: "cls-12",
    d: "M58.1,155.87a7.06,7.06,0,1,1-7.78-6.26h0a7.06,7.06,0,0,1,7.78,6.26h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    className: "cls-11",
    d: "M140.61,143.1a12.61,12.61,0,1,1-14.21-10.77h0a12.61,12.61,0,0,1,14.21,10.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    className: "cls-15",
    d: "M164.55,84.64a11,11,0,1,1-11-11h0a11,11,0,0,1,11,11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    className: "cls-10",
    d: "M30.82,61.34a7.1,7.1,0,1,1-7.1-7.1,7.1,7.1,0,0,1,7.1,7.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    className: "cls-22",
    d: "M109,88.92A17.18,17.18,0,1,1,91.86,71.74h0A17.18,17.18,0,0,1,109,88.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    className: "cls-15",
    d: "M41.77,122.11a9.92,9.92,0,1,1-9.91-9.91,9.92,9.92,0,0,1,9.91,9.91h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    className: "cls-12",
    d: "M153.9,44.26a17.42,17.42,0,1,1-17.41-17.41A17.42,17.42,0,0,1,153.9,44.26h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    className: "cls-14",
    d: "M82.86,34.7A14.67,14.67,0,1,1,68.2,20h0A14.66,14.66,0,0,1,82.86,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    className: "cls-5",
    d: "M137.93,41.6l1-.65a6.45,6.45,0,0,0-.5-1.54l-1.22.09a5.7,5.7,0,0,0-.39-.61l.57-1.07a6.88,6.88,0,0,0-1.21-1.08l-1,.68a5.46,5.46,0,0,0-.64-.32l-.05-1.22a7.14,7.14,0,0,0-1.59-.33l-.53,1.1a4.78,4.78,0,0,0-.53,0l-.19,0-.65-1a6.6,6.6,0,0,0-1.54.5l.09,1.22a6.17,6.17,0,0,0-.6.39l-1.08-.56a6.86,6.86,0,0,0-1.08,1.2l.69,1a4.31,4.31,0,0,0-.33.64l-1.22,0a7.25,7.25,0,0,0-.33,1.59l1.1.53a4.61,4.61,0,0,0,0,.53c0,.07,0,.13,0,.19l-1,.65a6.93,6.93,0,0,0,.5,1.54l1.22-.09c.12.21.25.41.39.61l-.56,1.07a6.87,6.87,0,0,0,1.21,1.07l1-.68c.21.12.43.23.65.33l.05,1.21a6.09,6.09,0,0,0,1.58.33l.53-1.09.54,0,.18,0,.65,1a7.49,7.49,0,0,0,1.54-.5l-.09-1.22a5.81,5.81,0,0,0,.61-.4l1.07.57a6.54,6.54,0,0,0,1.08-1.21l-.68-1a5.59,5.59,0,0,0,.32-.65l1.22,0a7.25,7.25,0,0,0,.33-1.59l-1.1-.53a4.61,4.61,0,0,0,0-.53,1.11,1.11,0,0,0,0-.19m-2.81.43a2.79,2.79,0,1,1-3-2.53h0a2.8,2.8,0,0,1,3,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    className: "cls-5",
    d: "M146,44.67a4.1,4.1,0,0,0-.53-.49l.23-.89a5.18,5.18,0,0,0-1-.54l-.62.68a4.46,4.46,0,0,0-.7-.17l-.25-.88a5.51,5.51,0,0,0-1.15,0l-.2.9a4.54,4.54,0,0,0-.69.21l-.65-.64a4.16,4.16,0,0,0-.51.28,5,5,0,0,0-.47.33l.28.87a4.18,4.18,0,0,0-.5.53l-.89-.23a6.53,6.53,0,0,0-.54,1l.68.62a4.18,4.18,0,0,0-.16.7l-.88.25a5.51,5.51,0,0,0,0,1.15l.9.19a4.33,4.33,0,0,0,.21.7l-.64.65a4.11,4.11,0,0,0,.27.51c.11.16.21.32.33.47l.88-.28a4,4,0,0,0,.52.49l-.22.89a5.48,5.48,0,0,0,1,.55l.62-.68a5.47,5.47,0,0,0,.7.16l.25.88a5.53,5.53,0,0,0,1.15,0l.19-.9a3.94,3.94,0,0,0,.69-.21l.66.64a4.82,4.82,0,0,0,.5-.27l.48-.33-.28-.88a6,6,0,0,0,.49-.52l.89.22a5.18,5.18,0,0,0,.54-1l-.68-.62a4.2,4.2,0,0,0,.17-.7l.88-.25a4.92,4.92,0,0,0,0-1.15l-.89-.19a3.94,3.94,0,0,0-.21-.69l.64-.66a5.53,5.53,0,0,0-.61-1Zm-1.63,2.06a2,2,0,1,1-2.75-.64,2,2,0,0,1,2.75.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    className: "cls-5",
    d: "M146.84,81.52v6.25a.8.8,0,0,0,.82.79h11.62a.81.81,0,0,0,.83-.79V81.53l-6.64,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    className: "cls-5",
    d: "M159.28,80.3H147.66a.82.82,0,0,0-.82.82v.14l6.63,3.28,6.64-3.28v-.14a.83.83,0,0,0-.83-.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    className: "cls-5",
    d: "M135.4,150.17l.45.27a1.11,1.11,0,0,0,1.08-1.82l-.47-.28a5.31,5.31,0,0,1-.48,1.06,4.71,4.71,0,0,1-.58.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    className: "cls-5",
    d: "M120,139.79a5.88,5.88,0,0,0,9.48,6.87l5.23,3.11A4.9,4.9,0,0,0,135.8,148l-5.2-3.1A5.88,5.88,0,0,0,120,139.79m8.61,5.12a4.13,4.13,0,1,1-1.44-5.66h0a4.14,4.14,0,0,1,1.44,5.66"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890",
    "data-name": "Rectangle 890",
    className: "cls-5",
    x: 59.33,
    y: 29.12,
    width: 18.05,
    height: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891",
    "data-name": "Rectangle 891",
    className: "cls-5",
    x: 59.33,
    y: 31.21,
    width: 18.05,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    className: "cls-5",
    x: 59.33,
    y: 33.3,
    width: 18.05,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    className: "cls-5",
    x: 59.33,
    y: 35.4,
    width: 18.05,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_894",
    "data-name": "Rectangle 894",
    className: "cls-5",
    x: 59.33,
    y: 37.49,
    width: 18.05,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_895",
    "data-name": "Rectangle 895",
    className: "cls-5",
    x: 59.33,
    y: 39.58,
    width: 8.98,
    height: 1.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    className: "cls-5",
    d: "M80.06,143.23h-.38V142a4.65,4.65,0,0,0-9.29-.1v1.32H70a1.42,1.42,0,0,0-1.42,1.41v6.71A1.42,1.42,0,0,0,70,152.76h10a1.41,1.41,0,0,0,1.41-1.41v-6.71a1.41,1.41,0,0,0-1.41-1.41h0M72.42,142a2.61,2.61,0,0,1,5.22,0v1.22H72.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    className: "cls-5",
    d: "M51.27,152.08l1.38,2.79,3.08.45-2.23,2.17.53,3.07-2.76-1.45-2.75,1.45.52-3.07-2.23-2.17,3.08-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    className: "cls-5",
    d: "M26.1,60.47h-.79a5.91,5.91,0,0,0-1.64-1.59,5.1,5.1,0,0,0-3.55-1l-.61-.38L20,58a5.07,5.07,0,0,0,1.26,3.48A6.18,6.18,0,0,0,22.92,63l.07.79A4.41,4.41,0,0,0,24.87,66a3,3,0,0,1,0-1.89l.52.25s.29,0,.84-.57.51-.89.51-.89l-.28-.49a3,3,0,0,1,1.88-.16,4.44,4.44,0,0,0-2.26-1.73M22.27,60a.52.52,0,1,1,0-.74h0a.52.52,0,0,1,0,.74h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    className: "cls-5",
    d: "M32.34,124.21A1.63,1.63,0,1,0,34,125.82a1.62,1.62,0,0,0-1.65-1.61h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    className: "cls-5",
    d: "M32.27,120.42a5.64,5.64,0,0,0-4.48,2.41l1.69,1.46a3.48,3.48,0,0,1,5.75,0l1.67-1.48a5.67,5.67,0,0,0-4.63-2.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    className: "cls-5",
    d: "M32.22,116.65a8.89,8.89,0,0,0-7.11,3.86L26.8,122A6.66,6.66,0,0,1,36,120.13,6.58,6.58,0,0,1,37.87,122l1.67-1.48a8.91,8.91,0,0,0-7.32-3.84"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploymentImg);
export default __webpack_public_path__ + "static/media/deploymentImg.dec075f263842e95e68e1477228131aa.svg";
export { ForwardRef as ReactComponent };